import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ExpensesCategoryChart } from "../charts/ExpensesCategoryChart";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, ResponsiveContainer } from 'recharts';

interface ExpenseChartsSectionProps {
  dailyData: Array<{ date: string; amount: number }>;
  categoryData: Array<{ name: string; value: number }>;
  formatCurrency: (amount: number) => string;
}

export const ExpenseChartsSection = ({ dailyData, categoryData, formatCurrency }: ExpenseChartsSectionProps) => {
  return (
    <div className="grid gap-6 md:grid-cols-2">
      <Card>
        <CardHeader>
          <CardTitle>Évolution des Dépenses</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-[300px]">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={dailyData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <RechartsTooltip 
                  formatter={(value: number) => [formatCurrency(value), "Montant"]}
                  labelFormatter={(label) => `Date: ${label}`}
                />
                <Bar dataKey="amount" fill="#f97316" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Répartition par Catégorie</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-[300px]">
            <ExpensesCategoryChart data={categoryData} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};